export const BENEFIT_ADOBE_ANALYTICS_INTEGRATION = 'adobe_analytics_integration';
export const BENEFIT_COBRANDING = 'cobranding';
export const BENEFIT_CORE_WEB_VITALS_ORIGIN_SUMMARY = 'core_web_vitals_origin_summary';
export const BENEFIT_CUSTOM_ALERT_TRIGGER = 'custom_alert_trigger';
export const BENEFIT_CUSTOM_ELEMENTS_0 = 'agency_custom_elements_0';
export const BENEFIT_CUSTOM_ELEMENTS_2 = 'agency_custom_elements_2';
export const BENEFIT_CUSTOM_ELEMENTS_5 = 'agency_custom_elements_5';
export const BENEFIT_CUSTOM_ELEMENTS_10 = 'agency_custom_elements_10';
export const BENEFIT_DATA_RETENTION_6_MONTHS = 'data_retention_6_months';
export const BENEFIT_DATA_RETENTION_9_MONTHS = 'data_retention_9_months';
export const BENEFIT_DATA_RETENTION_12_MONTHS = 'data_retention_12_months';
export const BENEFIT_GOOGLE_LOOKER_STUDIO = 'google_looker_studio';
export const BENEFIT_ISSUES_CONFIGURATION = 'issues_configuration';
export const BENEFIT_LIGHTHOUSE_MONITORING = 'lighthouse_monitoring';
export const BENEFIT_LOG_FILE_ANALYSIS = 'log_file_analysis';
export const BENEFIT_MICROSOFT_TEAMS = 'microsoft_teams';
export const BENEFIT_REALTIME_INDEX_NOW = 'realtime_index_now';
export const BENEFIT_RENDERING = 'rendering';
export const BENEFIT_REPORTING_API = 'reporting_api';
export const BENEFIT_UNLIMITED_USERS = 'unlimited_users';
export const BENEFIT_UNLIMITED_WEBSITES = 'unlimited_websites';

export const SECTION_ACCESS_CONTROL = 'accessControl';
export const SECTION_ADVANCED_ANALYSIS = 'advancedAnalysis';
export const SECTION_ADVANCED_FEATURES = 'advancedFeatures';
export const SECTION_COLLABORATION = 'collaboration';
export const SECTION_CORE_FEATURES = 'coreFeatures';
export const SECTION_INTEGRATIONS = 'integrations';
export const SECTION_MONITORING_SETTINGS = 'monitoringSettings';
export const SECTION_SERVICES = 'services';

export const LIST_OF_ALL_SECTIONS = [
	SECTION_ADVANCED_FEATURES,
	SECTION_ADVANCED_ANALYSIS,
	SECTION_INTEGRATIONS,
	SECTION_MONITORING_SETTINGS,
	SECTION_COLLABORATION,
	SECTION_SERVICES,
	SECTION_ACCESS_CONTROL,
] as const;
